module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/_scotland-8c8c1f079a4d5b4b0be8b0d4ce51f1c6.png";